import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Map, MapPin, Newspaper, Quote, Inbox, FileEdit, Home, ArrowUpRight } from "lucide-react";
import { adminGetStats } from "../admin/adminApi";

export default function CmsDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { adminGetStats().then(setStats).catch(() => {}); }, []);

  const cards = [
    { label: "Site Pages", value: 7, sub: "About · Contact · FAQ · Legal", icon: FileEdit, to: "/cms/pages", accent: "#14523d" },
    { label: "Homepage", value: "Editable", sub: "Hero, sections, CTA", icon: Home, to: "/cms/homepage", accent: "#d4af37" },
    { label: "Tours", value: stats?.tours ?? "—", sub: `${stats?.published_tours || 0} published`, icon: Map, to: "/cms/tours", accent: "#7c1d1d" },
    { label: "Destinations", value: stats?.destinations ?? "—", icon: MapPin, to: "/cms/destinations", accent: "#14523d" },
    { label: "Blog Posts", value: stats?.blog_posts ?? "—", icon: Newspaper, to: "/cms/blog", accent: "#d4af37" },
    { label: "Testimonials", value: stats?.testimonials ?? "—", icon: Quote, to: "/cms/testimonials", accent: "#7c1d1d" },
    { label: "Enquiries", value: stats?.enquiries ?? "—", sub: `${stats?.new_enquiries || 0} new`, icon: Inbox, to: "/cms/enquiries", accent: "#14523d" },
  ];

  return (
    <div data-testid="cms-dashboard">
      <div className="mb-10">
        <div className="text-[11px] tracking-[0.3em] uppercase text-[#14523d] font-semibold">Overview</div>
        <h1 className="font-serif text-4xl text-[#3b1a1a] mt-1">Good to see you.</h1>
        <p className="text-[#5a4b4b] mt-2">Everything on legacyindiatravel.com is editable from here — pick a section below to get started.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="cms-dashboard-cards">
        {cards.map((c) => (
          <Link key={c.label} to={c.to} className="bg-white border border-[#e5dfd2] hover:border-[#d4af37] p-5 rounded-lg transition-colors group flex items-start gap-4">
            <span className="w-11 h-11 rounded-md grid place-items-center text-white shrink-0" style={{ background: c.accent }}>
              <c.icon className="w-5 h-5" />
            </span>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between">
                <div className="text-[10px] tracking-[0.18em] uppercase text-[#5a4b4b]">{c.label}</div>
                <ArrowUpRight className="w-4 h-4 text-[#d4af37] opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
              <div className="font-serif text-3xl text-[#3b1a1a] mt-1">{c.value}</div>
              {c.sub && <div className="text-[11px] text-[#14523d] mt-1">{c.sub}</div>}
            </div>
          </Link>
        ))}
      </div>

      {/* Recent enquiries */}
      <div className="mt-10 bg-white border border-[#e5dfd2] rounded-lg overflow-hidden">
        <div className="px-6 py-4 border-b border-[#e5dfd2] flex items-center justify-between">
          <h2 className="font-serif text-2xl text-[#3b1a1a]">Recent Enquiries</h2>
          <Link to="/cms/enquiries" className="text-xs tracking-[0.2em] uppercase text-[#14523d]">View all →</Link>
        </div>
        <div className="divide-y divide-[#f0ead9]">
          {(stats?.recent_enquiries || []).map((e) => (
            <div key={e.id} className="px-6 py-4 flex items-center justify-between gap-4">
              <div>
                <div className="font-medium text-[#3b1a1a]">
                  {e.name} <span className="text-[#5a4b4b] font-normal">· {e.country}</span>
                </div>
                <div className="text-sm text-[#5a4b4b] clamp-2">{e.preferred_tour || e.message || e.email}</div>
              </div>
              <span
                className={`text-[10px] tracking-[0.15em] uppercase px-3 py-1 rounded-full ${
                  e.status === "new"
                    ? "bg-[#7c1d1d] text-white"
                    : e.status === "contacted"
                    ? "bg-[#d4af37] text-[#2d1616]"
                    : "bg-[#14523d] text-white"
                }`}
              >
                {e.status}
              </span>
            </div>
          ))}
          {(!stats?.recent_enquiries || stats.recent_enquiries.length === 0) && (
            <div className="px-6 py-10 text-center text-[#5a4b4b]">No enquiries yet.</div>
          )}
        </div>
      </div>
    </div>
  );
}
